/* eslint-disable no-unused-vars */
import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
enum ActionType {
  VEHICLE_SCHEDULE_ORDER = 'VEHICLE_SCHEDULE_ORDER',
}

export const actionFetchScheduleOrder = createAction<any>(
  eventProvider.makeResponseType(ActionType.VEHICLE_SCHEDULE_ORDER),
);

export default ActionType;
